import { Col, Row } from "antd";
import { RadialChart } from "react-vis";
import './statistics-chart.scss'
const StatisticsChart = ({ data }) => {
  return (
    <div className="gainer-types-container">
      <Row className="statistics-row-container" gutter={8}>
        <Col className="gutter-row dots-container" xxl={10} xl={10} lg={10} md={10} sm={24} xs={24}>
          <div className="numbers-container">
            {data.map((item) => (
              <div className="gainer-num">
                <h3>
                  <span
                    className="dot"
                    style={{ background: item.style.fill }}
                  ></span>{" "}
                  {item.label}
                </h3>
                <span>{item.angle}</span>
              </div>
            ))}
          </div>
        </Col>
        <Col className="gutter-row chart-row" xxl={14} xl={14} lg={14} md={14} sm={24} xs={24}>
          <RadialChart data={data} width={180} height={180} />
        </Col>
      </Row>
    </div>
  );
};
export default StatisticsChart;
